import {Company} from "../../../shared/model/company.model";

export class CompanyApplication extends Company {

}
